<template>
    <a v-if="document" :href="pdfLink" target="_blank">
        <i class="fal fa-file-pdf"></i> Export to PDF
    </a>
</template>

<script>
    export default {
        name: 'PdfLink',
        props: ['table', 'document'],
        data () {
            return {
                model: webase.model
            }
        },
        computed: {

            pdfExportAvailable() {
                if (this.hasRelatedTable) {
                    let relatedTable = webase.managers.app.getTable(this.relatedTableId)
                    return webase.utils.table.supportsPdf(relatedTable)
                }

                return false
            },
            pdfLink() {
                if (this.hasRelatedTable && this.hasRelatedDocument) {
                    return '/pdf/' + this.relatedTable.id + '/' + this.relatedDocumentId +
                        '/' + this.table.id + '/' + this.document['id']
                }

                return '#'
            },
            hasRelatedTable() {
                return this.linkedObjectField !== null
            },
            linkedObjectField() {
                return webase.utils.table.getLinkedObjectField(this.table)
            },
            relatedTableId() {
                return this.linkedObjectField.related_model_id
            },
            relatedTable() {
                return webase.managers.app.getTable(this.relatedTableId)
            },
            hasRelatedDocument() {
                let relatedObject = this.fieldValue(this.linkedObjectField)

                if (relatedObject) {
                    return Object.keys(relatedObject).length > 0
                }

                return false
            },
            relatedDocumentId() {
                let relatedObject = this.fieldValue(this.linkedObjectField)
                let documentIds = Object.keys(relatedObject)
                return documentIds.length > 0 ? documentIds[0] : null
            }
        },
        mounted () {
        },
        methods: {
            fieldValue(field) {
                if (field.field_type === 'Collaborator') {
                    return this.document[field.index].name
                }

                return this.document[field.index]
            }
        }
    }
</script>

<style>

</style>
